import {
  newTextField,
  textFieldPlacement,
  PORTRAIT_TEXT_PLACEMENT,
  LANDSCAPE_TEXT_PLACEMENT,
} from './textFieldDefaults';

describe('textFieldPlacement', () => {
  it('uses portrait placement when height >= width (portrait canvas)', () => {
    expect(textFieldPlacement(2400, 3000)).toEqual(PORTRAIT_TEXT_PLACEMENT);
  });

  it('uses portrait placement for a square canvas', () => {
    expect(textFieldPlacement(2400, 2400)).toEqual(PORTRAIT_TEXT_PLACEMENT);
  });

  it('uses landscape placement when width > height (landscape collage)', () => {
    expect(textFieldPlacement(3000, 2400)).toEqual(LANDSCAPE_TEXT_PLACEMENT);
  });

  it('falls back to portrait when dimensions are missing', () => {
    expect(textFieldPlacement(undefined, undefined)).toEqual(PORTRAIT_TEXT_PLACEMENT);
  });
});

describe('newTextField', () => {
  it('places a portrait field low-center across the full width', () => {
    expect(newTextField(0, 2400, 3000)).toMatchObject({
      position: 0,
      center_x: 0.5,
      center_y: 0.85,
      bound_x_left: 0.04,
      bound_x_right: 0.96,
      align: 'center',
    });
  });

  it('places a landscape field on the right, beside the photo', () => {
    expect(newTextField(1, 3000, 2400)).toMatchObject({
      position: 1,
      center_x: 0.75,
      center_y: 0.5,
      bound_x_left: 0.55,
      bound_x_right: 0.96,
      align: 'center',
    });
  });

  it('keeps the shared (non-positional) defaults identical across orientations', () => {
    const shared = {
      content: '{{first_name}}',
      font_s3_path: 's3://shoobphoto/fonts/',
      font_filename: 'ADAM-CG-PRO.REGULAR.OTF',
      font_color: '#000000',
      font_size_min: 80,
      font_size_max: 160,
      sizing_rule: 'shrink_to_fit',
      bold: false,
      italic: false,
      shadow: false,
    };
    expect(newTextField(0, 2400, 3000)).toMatchObject(shared);
    expect(newTextField(0, 3000, 2400)).toMatchObject(shared);
  });
});
